import { useDevicesStore } from "entities/devices/model/store";
import { useMemo } from "react";
import { DeviceRow } from "entities/devices/model/types";
import { TableStyles } from "react-data-table-component";
import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import { useLocation } from "react-router-dom";

export const useDevicesTable = () => {
    const devices = useDevicesStore((s) => s.devices);
    const { search } = useLocation();

    const hiveIdParam = useMemo(() => {
        const v = new URLSearchParams(search).get("hiveId");
        return v ? v.replace(/"/g, "") : null;
    }, [search]);

    const rows = useMemo<DeviceRow[]>(
        () => (hiveIdParam ? devices.filter((d) => (d.hiveId || "") === hiveIdParam) : devices),
        [devices, hiveIdParam]
    );

    const customStyles: TableStyles = useMemo(
        () => ({
            table: { style: { backgroundColor: "transparent" } },
            headRow: {
                style: {
                    position: "sticky",
                    top: 0,
                    zIndex: 5,
                    backgroundColor: COLORS.BG.SURFACE3,
                    borderTop: `${toRem(1)} solid ${COLORS.BORDER.SOFT}`,
                    borderBottom: `${toRem(1)} solid ${COLORS.BORDER.SOFT}`,
                    minHeight: "36px!important",
                    color: COLORS.FG.DEFAULT,
                },
            },
            rows: {
                style: {
                    minHeight: "40px!important",
                    borderBottom: `${toRem(1)} solid ${COLORS.BORDER.MUTED}`,
                    backgroundColor: "transparent",
                    color: COLORS.FG.DEFAULT,
                },
            },
            noData: { style: { backgroundColor: "transparent", color: COLORS.FG.DEFAULT } },
        }),
        []
    );

    return {
        customStyles,
        rows,
    };
};
